const state = {
    cartNum: localStorage.getItem('cartNum') ? localStorage.getItem('cartNum') : 0, //购物车,涉及到刷新数据丢失，所以存了本地,
    cartList: [], //购物车数据
    userInfo: {},

}

export default state;


// WEBPACK FOOTER //
// ./src/store/store.js